module.exports = __webpack_public_path__ + "static/media/check_inpu_icon.23e99560.svg";